import { MessageCircle, Plus } from "lucide-react";
import { Button } from "components/ui/button";
import { Badge } from "components/ui/badge";
import { cn } from "@/lib/utils";
import { useCallback } from "react";

const CONSTANTS = {
  MAX_DISPLAY_COUNT: 99,
} as const;

interface ChatIconWithBadgeProps {
  commentCount: number;
  onClick: () => void;
  className?: string;
}

export function ChatIconWithBadge({ commentCount, onClick, className }: ChatIconWithBadgeProps) {
  const hasComments = commentCount > 0;
  const displayCount = commentCount > CONSTANTS.MAX_DISPLAY_COUNT ? "99+" : commentCount;
  
  const handleClick = useCallback((e: React.MouseEvent) => { 
    e.preventDefault(); 
    e.stopPropagation(); 
    onClick?.(); 
  }, [onClick]);

  return (
    <Button 
      variant="ghost" 
      size="sm" 
      onClick={handleClick} 
      className={cn("relative p-1 h-8 w-8 bg-white hover:bg-gray-50 border border-gray-200 transition-colors rounded-md", className)}
      aria-label={hasComments ? `Ver ${commentCount} comentário${commentCount !== 1 ? 's' : ''}` : "Adicionar comentário"}
    >
      {hasComments ? (
        <>
          <MessageCircle className="h-4 w-4 text-black" aria-hidden="true" />
          <Badge 
            className="absolute -top-1 -right-1 h-5 w-5 rounded-full p-0 flex items-center justify-center text-xs font-medium bg-yellow-500 text-black border-yellow-600 hover:bg-yellow-600"
            aria-label={`${commentCount} comentários`}
          >
            {displayCount}
          </Badge>
        </>
      ) : (
        <Plus className="h-4 w-4 text-black hover:text-gray-600" aria-hidden="true" />
      )}
    </Button>
  );
}
